// extracted by mini-css-extract-plugin
export var deleteIcon = "_qs-5";
export var deleteOption = "_qs-3";
export var divider = "_qs-2";
export var downloadIcon = "_qs-4";
export var drawer = "_qs-0";
export var drawerFooter = "_qs-6";
export var drawerOpen = "_qs-1";
export var highlighted = "_qs-7";
export var lighterHighlight = "_qs-8";